export function authInitialised(state) {
  return state.authInitialised
}
export function loggedIn(state) {
  return state.isLoggedIn
}
export function userProfile(state) {
  return state.userProfile
}
